<template>
  <div class="edit-usuario">
    <h1>Editar Usuario</h1>
    
    <div class="alert alert-info" v-if="loading">Cargando usuario...</div>
    <div class="alert alert-danger" v-if="error">{{ error }}</div>
    
    <form @submit.prevent="updateUsuario" class="mt-4" v-if="!loading && !error">
      <div class="mb-3">
        <label for="usuario_id" class="form-label">ID de Usuario *</label>
        <input 
          type="text" 
          class="form-control" 
          id="usuario_id" 
          :value="usuario.UsuarioId"
          @input="updateField('UsuarioId', $event.target.value)"
          required
          maxlength="20"
          readonly
        >
        <small class="form-text text-muted">El ID no se puede modificar</small>
      </div>
      
      <div class="mb-3">
        <label for="password" class="form-label">Contraseu00f1a</label>
        <input 
          type="password" 
          class="form-control" 
          id="password" 
          :value="usuario.Password"
          @input="updateField('Password', $event.target.value)"
          placeholder="Dejar en blanco para mantener la actual"
          maxlength="40"
        >
        <small class="form-text text-muted">Mu00e1ximo 40 caracteres. Dejar en blanco para mantener la contraseu00f1a actual.</small>
      </div>
      
      <div class="mb-3">
        <label for="nombre" class="form-label">Nombre</label>
        <input 
          type="text" 
          class="form-control" 
          id="nombre" 
          :value="usuario.Nombre"
          @input="updateField('Nombre', $event.target.value)"
          maxlength="60"
        >
        <small class="form-text text-muted">Mu00e1ximo 60 caracteres</small>
      </div>
      
      <div class="mb-3">
        <label for="email" class="form-label">Email</label>
        <input 
          type="email" 
          class="form-control" 
          id="email" 
          :value="usuario.Email"
          @input="updateField('Email', $event.target.value)"
          maxlength="80"
        >
        <small class="form-text text-muted">Mu00e1ximo 80 caracteres</small>
      </div>
      
      <div class="mb-3 form-check">
        <input 
          type="checkbox" 
          class="form-check-input" 
          id="es_activo" 
          :checked="usuario.EsActivo"
          @change="updateField('EsActivo', $event.target.checked); handleActiveChange()"
        >
        <label class="form-check-label" for="es_activo">Usuario Activo</label>
      </div>
      
      <div class="mb-3">
        <label for="fecha_confirmacion" class="form-label">Fecha de Confirmaciu00f3n</label>
        <input 
          type="datetime-local" 
          class="form-control" 
          id="fecha_confirmacion" 
          v-model="fechaConfirmacionLocal"
          :disabled="!usuario.EsActivo"
        >
        <small class="form-text text-muted">Fecha y hora de confirmaciu00f3n del usuario</small>
      </div>
      
      <div class="mb-3">
        <label for="zempleado" class="form-label">ZEmpleado</label>
        <input 
          type="text" 
          class="form-control" 
          id="zempleado" 
          :value="usuario.ZEmpleado"
          @input="updateField('ZEmpleado', $event.target.value)"
          maxlength="20"
        >
        <small class="form-text text-muted">Mu00e1ximo 20 caracteres</small>
      </div>
      
      <div class="mb-3">
        <label for="zserie" class="form-label">ZSerie</label>
        <input 
          type="text" 
          class="form-control" 
          id="zserie" 
          :value="usuario.ZSerie"
          @input="updateField('ZSerie', $event.target.value)"
          maxlength="20"
        >
        <small class="form-text text-muted">Mu00e1ximo 20 caracteres</small>
      </div>
      
      <div class="mb-3">
        <label for="usuario_id_consulta" class="form-label">Usuario ID Consulta</label>
        <input 
          type="text" 
          class="form-control" 
          id="usuario_id_consulta" 
          :value="usuario.UsuarioIdConsulta"
          @input="updateField('UsuarioIdConsulta', $event.target.value)"
          maxlength="200"
        >
        <small class="form-text text-muted">Mu00e1ximo 200 caracteres</small>
      </div>
      
      <div class="d-flex gap-2">
        <button type="submit" class="btn btn-primary" :disabled="saving">
          <span v-if="saving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          <i v-else class="bi bi-save me-1"></i>
          Actualizar
        </button>
        <router-link to="/config/usuarios" class="btn btn-secondary">
          <i class="bi bi-x-circle me-1"></i> Cancelar
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import { useAccessControl } from '@/composables/useAccessControl'
import { EditUsuarioController } from '../controllers/EditUsuarioCtrl.js';

export default {
  name: 'EditUsuarioView',
  props: ['id'],
  setup() {
    const { requiresAuth, requiresMenuPermission } = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    })

    return {
      requiresAuth,
      requiresMenuPermission
    }
  },
  data() {
    return {
      controller: new EditUsuarioController()
    };
  },
  computed: {
    usuario() {
      return this.controller.getUsuario();
    },
    fechaConfirmacionLocal: {
      get() {
        return this.controller.getFechaConfirmacionLocal();
      },
      set(value) {
        this.controller.updateFechaConfirmacion(value);
      }
    },
    loading() {
      return this.controller.isLoading();
    },
    saving() {
      return this.controller.isSaving();
    },
    error() {
      return this.controller.getError();
    }
  },
  async mounted() {
    const usuarioId = this.$route.params.id;
    if (usuarioId) {
      await this.controller.init(usuarioId);
    }
  },
  methods: {
    updateField(field, value) {
      this.controller.updateField(field, value);
    },
    async updateUsuario() {
      try {
        const result = await this.controller.updateUsuario();
        if (result.success) {
          alert(result.message);
          this.$router.push('/config/usuarios');
        }
      } catch (error) {
        // El error ya está manejado en el controlador
        console.error('Error al actualizar usuario:', error);
      }
    },
    handleActiveChange() {
      this.controller.handleActiveChange();
    }
  }
}
</script>

<style scoped>
.edit-usuario {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
</style>
